import globals from "../partials/global-variables";
import stylesConfig from "../styles.config";

const textGray = "#999";

export default {
  container: {
    margin: "0 auto 10px",
    "& p": {
      margin: "0 0 5px",
      fontSize: stylesConfig.typography.fontSize(0.9),
      fontWeight: 400,
      [`@media (${globals.breakpoints.$xs})`]: {
        fontSize: stylesConfig.typography.fontSize(0.9),
      },
    },
    "& .question-validation-message": {
      fontSize: stylesConfig.typography.fontSize(0.8),
    },
    "& .input-wrapper": {
      margin: 0,
      // border: `1px solid ${globals.colors.lightGray}`,
      width: "100%",
      padding: ["9px", "10px"],
      backgroundColor: globals.colors.white,
    },
    "& input": {
      width: "100%",
      background: "transparent",
      border: 0,
      fontSize: stylesConfig.typography.fontSize(0.8),
      outline: 0,
      color: textGray,
      fontWeight: 700,
    },
  },
};
